import { Avatar, AvatarSize } from "@amzn/stencil-react-components/avatar";
import { Text } from "@amzn/stencil-react-components/text";
import React, { FC } from "react";

const BADGE_PHOTO_URL: string = "https://badgephotos.corp.amazon.com/?fullsizeimage=1&give404ifmissing=1&uid=";

/**
 * Represents the properties for the UserAvatar component.
 * @interface
 * @property {string} login - The unique username or login identifier of the user.
 * @property {string} name - The display name of the user.
 */
interface UserAvatarProps {
  login: string;
  name: string;
}

export const UserAvatar: FC<UserAvatarProps> = ({ login, name }) => (
  <Avatar
    username={login}
    size={AvatarSize.Small}
    showUsername={false}
    fullName={name}
    renderNameWrapper={(name) => <Text fontWeight={"medium"}>{name}</Text>}
    profileImageUrl={`${BADGE_PHOTO_URL}${login}`}
    renderImageWrapper={(avatarImage) => <div className="rounded-avatar">{avatarImage}</div>}
    showImage={true}
  />
);
